import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-main flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap">
            欧美一区二区
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? 'text-primary-600 bg-primary-50'
                : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.includes(cat.slug)
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-primary-600 bg-primary-50'
                : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="container-main py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.id} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100">{cat.name}</Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100">关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
}